import { useState, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import transactionService from '../services/transactionService';

export const useDetailedPortfolio = () => {
  const { user } = useAuth();
  const [detailedPortfolio, setDetailedPortfolio] = useState(null);
  const [loading, setLoading] = useState(false);

  console.log('🏪 useDetailedPortfolio hook called', { userId: user?._id, hasPortfolio: !!detailedPortfolio, loading });

  const loadDetailedPortfolio = useCallback(async () => {
    console.log('🚀 loadDetailedPortfolio called');
    
    const currentUser = user || { _id: localStorage.getItem('userId') };
    if (!currentUser?._id) {
      console.log('❌ No user ID, skipping portfolio load');
      return;
    }
    
    setLoading(prev => {
      if (prev) {
        console.log('⏳ Already loading, skipping');
        return prev;
      }
      console.log('⏳ Starting to load portfolio');
      return true;
    });
    
    try {
      const userId = currentUser._id;
      console.log('📡 Fetching portfolio for userId:', userId);
      const response = await transactionService.getPortfolio(userId);
      
      if (response.success) {
        console.log('✅ Portfolio data received:', response.data);
        setDetailedPortfolio(response.data);
      } else {
        console.log('❌ Portfolio fetch unsuccessful:', response);
      }
    } catch (error) {
      console.error('💥 Error loading detailed portfolio:', error);
    } finally {
      console.log('🏁 Portfolio load complete, setting loading to false');
      setLoading(false);
    }
  }, [user?._id]); // Only depend on user ID, not entire user object

  return {
    detailedPortfolio,
    loading,
    loadDetailedPortfolio
  };
};